import firebase from 'firebase/app';
import 'firebase/auth';

import config from '../config/constants';

firebase.initializeApp(config.firebase);

export default firebase;